import { StoreScheduleResponse } from '@ydistri/api-sdk';
import { Column, Text } from '@ydistri/ds';
import { Popover } from 'antd';
import React, { PropsWithChildren, useMemo } from 'react';
import { MdWarning } from 'react-icons/md';
import { describeRestrictions } from './storesScheduleLib';

interface MultiActiveWarningProps extends PropsWithChildren {
  siblings: StoreScheduleResponse[];
}

/**
 * Marks a store that has more than one active record. Overlapping periods for one store are
 * allowed, so this only points at the other records rather than reporting a problem.
 */
const MultiActiveWarning: React.FC<MultiActiveWarningProps> = ({ siblings, children }) => {
  const popoverContent = useMemo(
    () => (
      <Column>
        <Text>This store has other active records in the schedule:</Text>
        <ul>
          {siblings.map(sibling => (
            <li key={sibling.storeScheduleId}>{describeRestrictions(sibling)}</li>
          ))}
        </ul>
      </Column>
    ),
    [siblings],
  );

  if (siblings.length === 0) {
    return children;
  } else {
    return (
      <Popover content={popoverContent}>
        <Text $type="warning">
          <MdWarning size={16} /> {children}
        </Text>
      </Popover>
    );
  }
};

export default MultiActiveWarning;
